<ng-container *ngIf="zoomTexts$ | async as texts">
    <section class="t-zoom">
        <button
            tuiIconButton
            tuiPreviewAction
            type="button"
            class="t-sign_minus"
            [disabled]="leftButtonDisabled"
            [icon]="icons.zoomOut"
            [title]="texts.zoomOut"
            (click)="onMinus()"
        ></button>
        <label tuiSliderThumbLabel>
            <div
                tuiHintAppearance="onDark"
                tuiHintDirection="top-right"
                [tuiHint]="hint"
                [tuiHintManual]="!!(hintShow$ | async)"
            ></div>

            <ng-template #hint>
                {{ (valueChange | async) || value | percent }}
            </ng-template>

            <input
                step="any"
                tuiSlider
                type="range"
                class="t-slider"
                [max]="max"
                [min]="min"
                [ngModel]="value"
                (ngModelChange)="onModelChange($event)"
            />
        </label>
        <button
            tuiIconButton
            tuiPreviewAction
            type="button"
            class="t-sign_plus"
            [disabled]="rightButtonDisabled"
            [icon]="icons.zoomIn"
            [title]="texts.zoomIn"
            (click)="onPlus()"
        ></button>
    </section>

    <button
        tuiHintAppearance="onDark"
        tuiHintDescribe
        tuiHintDirection="top-right"
        tuiIconButton
        tuiPreviewAction
        type="button"
        class="t-reset-button"
        [class.t-invisible]="!collapseVisible"
        [icon]="icons.zoomReset"
        [tuiHint]="texts.reset"
        (click)="onReset()"
    ></button>
</ng-container>
